<template>
  <div class="table-responsive">
  <table class="table table-bordered table-hover table-striped table-dark border border-dark shadow-lg" id="dataTable" width="100%" cellspacing="0">
    <thead>
    <tr>
      <th v-for="(value,key) in titles" :key="key">{{value}}</th>
    </tr>
    </thead>
    <tfoot>
    <tr>
      <th v-for="(value,key) in titles" :key="key">{{value}}</th>
    </tr>
    </tfoot>
    <tbody>
      <slot/>
    </tbody>
  </table>
  </div>
</template>

<script>
export default {
  name: 'TableContainer',
  props: {
    titles: {
      required: true,
      type: Array
    }
  }
}
</script>

<style scoped>

</style>
